import { render, staticRenderFns } from "./pruebaapi.vue?vue&type=template&id=73f335e4"
import script from "./pruebaapi.vue?vue&type=script&lang=js"
export * from "./pruebaapi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports